export const GET_DOWNLOAD_PENGURUS_PUSAT = "GET_DOWNLOAD_PENGURUS_PUSAT";
export const GET_DOWNLOAD_PENGURUS_PUSAT_SUCCESS = "GET_DOWNLOAD_PENGURUS_PUSAT_SUCCESS";
export const GET_DOWNLOAD_PENGURUS_PUSAT_FAIL = "GET_DOWNLOAD_PENGURUS_PUSAT_FAIL";

export const GET_DOWNLOAD_PENGURUS_PROVINSI = "GET_DOWNLOAD_PENGURUS_PROVINSI";
export const GET_DOWNLOAD_PENGURUS_PROVINSI_SUCCESS = "GET_DOWNLOAD_PENGURUS_PROVINSI_SUCCESS";
export const GET_DOWNLOAD_PENGURUS_PROVINSI_FAIL = "GET_DOWNLOAD_PENGURUS_PROVINSI_FAIL";

export const GET_DOWNLOAD_PENGURUS_KABKOT = "GET_DOWNLOAD_PENGURUS_KABKOT";
export const GET_DOWNLOAD_PENGURUS_KABKOT_SUCCESS = "GET_DOWNLOAD_PENGURUS_KABKOT_SUCCESS";
export const GET_DOWNLOAD_PENGURUS_KABKOT_FAIL = "GET_DOWNLOAD_PENGURUS_KABKOT_FAIL";

export const GET_DOWNLOAD_PENGURUS_KECAMATAN = "GET_DOWNLOAD_PENGURUS_KECAMATAN";
export const GET_DOWNLOAD_PENGURUS_KECAMATAN_SUCCESS = "GET_DOWNLOAD_PENGURUS_KECAMATAN_SUCCESS";
export const GET_DOWNLOAD_PENGURUS_KECAMATAN_FAIL = "GET_DOWNLOAD_PENGURUS_KECAMATAN_FAIL";

export const GET_DOWNLOAD_REKAP_PENGURUS_PUSAT = "GET_DOWNLOAD_REKAP_PENGURUS_PUSAT";
export const GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_SUCCESS = "GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_SUCCESS";
export const GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_FAIL = "GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_FAIL";

export const GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI = "GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI";
export const GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_SUCCESS = "GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_SUCCESS";
export const GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_FAIL = "GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_FAIL";

export const GET_DOWNLOAD_REKAP_PENGURUS_KABKOT = "GET_DOWNLOAD_REKAP_PENGURUS_KABKOT";
export const GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_SUCCESS = "GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_SUCCESS";
export const GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_FAIL = "GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_FAIL";

export const GET_DOWNLOAD_REKAP_ANGGOTA = "GET_DOWNLOAD_REKAP_ANGGOTA";
export const GET_DOWNLOAD_REKAP_ANGGOTA_SUCCESS = "GET_DOWNLOAD_REKAP_ANGGOTA_SUCCESS";
export const GET_DOWNLOAD_REKAP_ANGGOTA_FAIL = "GET_DOWNLOAD_REKAP_ANGGOTA_FAIL";

export const GET_DOWNLOAD_DAFTAR_ANGGOTA = "GET_DOWNLOAD_DAFTAR_ANGGOTA";
export const GET_DOWNLOAD_DAFTAR_ANGGOTA_SUCCESS = "GET_DOWNLOAD_DAFTAR_ANGGOTA_SUCCESS";
export const GET_DOWNLOAD_DAFTAR_ANGGOTA_FAIL = "GET_DOWNLOAD_DAFTAR_ANGGOTA_FAIL";
